// Authors: Ben Croker
// Icon: material-symbols:timer-play-outline
// Slug: Runs an expression when the element is loaded
// Description: This attribute runs an expression when the element is loaded.

import type { AttributePlugin } from '../../../engine/types'
import { tagToMs } from '../../../utils/tags'
import { delay } from '../../../utils/timing'
import { modifyViewTransition } from '../../../utils/view-transitions'

export const OnLoad: AttributePlugin = {
  type: 'attribute',
  name: 'onLoad',
  keyReq: 'denied',
  valReq: 'must',
  onLoad: ({ rx, mods }) => {
    let callback = () => rx()
    callback = modifyViewTransition(callback, mods)
    let wait = 0
    const delayArgs = mods.get('delay')
    if (delayArgs) {
      wait = tagToMs(delayArgs)
    }
    // Delay the callback regardless of whether the modifier is set so that other plugins are processed first.
    callback = delay(callback, wait)
    callback()
  },
}
